import React, { FC } from 'react';
import { Grid, IconButton, Link, Tooltip, Typography } from '@material-ui/core';
import { Trans, useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';

import { PaddedPaper } from 'components';

import Sources from './Sources';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

const useStyles = makeStyles(theme => ({
  paper: {
    padding: theme.spacing(4, 4, 5, 3),
  },
  link: {
    textDecoration: 'underline',
  },
  tooltipButton: {
    padding: 0,
  },
}));

const GroupSources: FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  function renderHelpCenterLink() {
    return (
      <Link
        className={classes.link}
        href="https://help.everyonesocial.app/hc/en-us/articles/4420170424855-Source-Group-Content-Using-RSS-Feeds-Mentions-and-Keywords"
        target="_blank"
      >
        Help Center Article
      </Link>
    );
  }

  function renderGroupsSourceInfo() {
    return (
      <Trans i18nKey={'groups:infoTooltip'}>
        See our {renderHelpCenterLink()} to learn more about how to use group sources in your group
        feed.
      </Trans>
    );
  }

  return (
    <PaddedPaper square className={classes.paper}>
      <Grid container>
        <Grid item xs={3}>
          <Grid container item xs={4}>
            <Typography variant="subtitle2">{t('groups:sources')}</Typography>
            <Tooltip interactive title={renderGroupsSourceInfo()} leaveDelay={500}>
              <IconButton className={classes.tooltipButton}>
                <InfoOutlinedIcon fontSize="small" color="disabled" />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
        <Grid container item xs>
          <Sources />
        </Grid>
      </Grid>
    </PaddedPaper>
  );
};

export default GroupSources;
